module.exports = __webpack_public_path__ + "img/Logo_Digiasia_White2.4487b01d.png";